import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-reminder-menu',
    templateUrl: './reminder-menu.component.html',
    styleUrls: ['./reminder-menu.component.scss'],
    imports: [TranslateModule],
})
export class ReminderMenuComponent {
    readonly MINUTES_PER_HOUR = 60;
    readonly MINUTES_PER_DAY = 24 * this.MINUTES_PER_HOUR;

    readonly TWENTY_MINUTES = 20;
    readonly ONE_HOUR_IN_MINUTES = this.MINUTES_PER_HOUR;
    readonly THREE_HOURS_IN_MINUTES = 3 * this.MINUTES_PER_HOUR;
    readonly ONE_DAY_IN_MINUTES = this.MINUTES_PER_DAY;
    readonly TWO_DAYS_IN_MINUTES = 2 * this.MINUTES_PER_DAY;
    readonly SEVEN_DAYS_IN_MINUTES = 7 * this.MINUTES_PER_DAY;
    readonly FOURTEEN_DAYS_IN_MINUTES = 14 * this.MINUTES_PER_DAY;
    readonly THIRTY_DAYS_IN_MINUTES = 30 * this.MINUTES_PER_DAY;

    @Input() hasReopenOption: boolean;
    @Input() isReminderAdded: boolean;
    @Input() isReopen: boolean;
    @Input() isSaving: boolean;

    @Output() isReopenClick: EventEmitter<boolean> = new EventEmitter();
    @Output() pickDateAndTimeClick: EventEmitter<void> = new EventEmitter();
    @Output() remindClick: EventEmitter<number> = new EventEmitter();
    @Output() removeReminderClick: EventEmitter<void> = new EventEmitter();
}
